import type { ProgressProps } from '@mantine/core'
import { Progress as MantineProgress, useMantineTheme } from '@mantine/core'

export function Progress({ ...props }: ProgressProps) {
  const theme = useMantineTheme()

  return <MantineProgress color={theme.other.colors.green} {...props} />
}
